import { ArticleHeading1, useDeviceType } from '@cian/ui-kit';
import * as style from './styles.css';

interface ITitleProps {
  children: JSX.Element | string;
}

export const Title: React.FC<ITitleProps> = ({ children }) => {
  const device = useDeviceType();

  return (
    <div className={style['title']}>
      <ArticleHeading1 textAlign={device === 'phone' ? 'left' : 'center'}>{children}</ArticleHeading1>
    </div>
  );
};
